import { useState } from 'react';
import { Accordion } from '@belong/ui';
import {
  defaultItems,
  renewalItems,
} from 'lease-signing-flow-v2/constants/deposit';

type DepositFAQsProps = {
  isRenewal: boolean;
};

export const DepositFAQs = ({ isRenewal }: DepositFAQsProps) => {
  const [openFAQIndex, setOpenFAQIndex] = useState<number | null>(0);

  const handleChange = (index: number) =>
    setOpenFAQIndex(openFAQIndex === index ? null : index);
  return (
    <Accordion
      // @ts-expect-error -- Legacy typecheck baseline; see docs/development/typecheck-baseline-followups.md. Refs: ARCH-56
      index={openFAQIndex}
      items={isRenewal ? renewalItems : defaultItems}
      onChange={handleChange}
    />
  );
};
